var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"statusBar"},[_vm._v("Cargando...")]):_vm._e(),_c('Generador'),_c('ListaEmpleados')],1)}
var staticRenderFns = []

export { render, staticRenderFns }